// extracted by mini-css-extract-plugin
module.exports = {"container":"_2bnuvt","tablist":"_2iqbRI","tab":"_17_0i7","selected":"_3iuu3O","tabpannel":"_3B-Wgq","selectedTabPanel":"_29hFfg"};